import { createSelector } from 'reselect';

// Actions
export const SET_IS_SELECTING_SSEMBLE_MEDIA = 'ssemble/SET_IS_SELECTING_SSEMBLE_MEDIA';

// Initial state
const initialState = {
  isSelectingSsembleMedia: false,
};

// Reducers
export function ssembleRequestReducer(state = initialState, action) {
  switch (action.type) {
    case SET_IS_SELECTING_SSEMBLE_MEDIA: {
      const newState = {
        ...state,
        isSelectingSsembleMedia: action.value,
      };

      return newState;
    }

    default: {
      return state;
    }
  }
}

// Action Creators
export function setIsSelectingSsembleMedia(value) {
  return {
    type: SET_IS_SELECTING_SSEMBLE_MEDIA,
    value
  };
}

// Selectors
export const getSsembleState = createSelector(
  (state) => state,
  (state) => state.get('ssemble')
);

export const getIsSelectingSsembleMedia = createSelector(
  getSsembleState,
  (ssembleState) => ssembleState?.isSelectingSsembleMedia
);



// WEBPACK FOOTER //
// ./src/redux/modules/ssemble.js